export default __webpack_public_path__ + "static/1185-062e514227807ccc07bc5ba9e8577531.gif";